import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotifierService {
  constructor(private messageService: MessageService, private translateService: TranslateService) {}

  openSuccessToast(message: string, params: any = {}): void {
    this.openToast(message, params, 'success');
  }

  openErrorToast(message: string, params: any = {}): void {
    this.openToast(message, params, 'error');
  }

  openInfoToast(message: string, params: any = {}): void {
    this.openToast(message, params, 'info');
  }

  private openToast(message: string, params: any = {}, severity: string): void {
    this.messageService.add({
      severity,
      detail: this.translateService.instant(message, params)
    });
  }
}
